import util from '../util'

let controller = 'FeatureFlag'

export default {
  Get: function (feature) {
    return util.Axios.Get(controller, feature)
  }
}